import { Header } from "@src/components"
import { ar } from "@src/i18n/ar"
import { OrderForm } from "@src/components/order-form"

export default function NewOrder() {
  return (
    <>
      <Header title={ar.newOrder} />
      <OrderForm />
    </>
  )
}
